/* Homvista drawer: preserve Shopify checkout and native subtotal; add real discount and shipping presentation. */
(function () {
  'use strict';
  var observed = new WeakSet();
  var lastFooter = null;
  var lastNativeSubtotal = null;
  var discountRequest = 0;
  var lockIcon = '<svg class="hv-cd-lock" viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path fill="currentColor" d="M18 9h-1V7a5 5 0 0 0-10 0v2H6a2 2 0 0 0-2 2v9a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-9a2 2 0 0 0-2-2ZM9 7a3 3 0 0 1 6 0v2H9V7Z"/></svg>';

  function formatSavings(cents, cart) {
    var currency = (cart && cart.currency) || (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'USD';
    try { return new Intl.NumberFormat('en-US', { style: 'currency', currency: currency }).format(cents / 100); }
    catch (error) { return '$' + (cents / 100).toFixed(2); }
  }

  function updateActualDiscount(footer, cart, request) {
    if (request !== discountRequest || !footer.isConnected) return;
    var discount = Number(cart.total_discount);
    if (!Number.isFinite(discount)) discount = Number(cart.original_total_price) - Number(cart.total_price);
    if (!Number.isFinite(discount)) return;
    discount = Math.max(0, discount);
    var row = footer.querySelector('.hv-cd-row--discount');
    if (discount > 0) {
      if (!row) {
        row = document.createElement('div');
        row.className = 'hv-cd-row hv-cd-row--discount';
        row.innerHTML = '<span class="hv-cd-label">Discounts</span><strong class="hv-cd-value"></strong>';
        var shipping = footer.querySelector('.hv-cd-row--shipping');
        if (shipping) shipping.insertAdjacentElement('afterend', row);
      }
      var value = row.querySelector('.hv-cd-value');
      var money = '−' + formatSavings(discount, cart);
      if (value && value.textContent !== money) value.textContent = money;
      footer.classList.add('hv-cd-has-discount');
    } else {
      if (row) row.remove();
      footer.classList.remove('hv-cd-has-discount');
    }
  }

  function fetchActualDiscount(footer) {
    var request = ++discountRequest;
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    var cartUrl = root.replace(/\/?$/, '/') + 'cart.js';
    fetch(cartUrl, { credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then(function (response) { if (!response.ok) throw new Error('Cart request failed'); return response.json(); })
      .then(function (cart) { updateActualDiscount(footer, cart, request); })
      .catch(function () { /* Leave Shopify's native discount display intact if data cannot load. */ });
  }

  function enhance() {
    var drawer = document.querySelector('cart-drawer') || document.getElementById('CartDrawer');
    if (!drawer) return;
    var button = drawer.querySelector('#CartDrawer-Checkout');
    if (button) {
      var label = button.querySelector('.button__label');
      if (label && !label.querySelector('.hv-cd-secure')) {
        label.innerHTML = '<span class="hv-cd-secure">' + lockIcon + '<span>Secure checkout</span></span>';
      }
    }
    var footer = drawer.querySelector('.drawer__footer .cart-drawer__footer');
    if (!footer) return;
    var totals = footer.querySelector('.cart-drawer__totals');
    if (!totals) return;
    if (!footer.classList.contains('hv-cd-summary')) footer.classList.add('hv-cd-summary');
    if (!footer.querySelector('.hv-cd-row--shipping')) {
      var shipping = document.createElement('div');
      shipping.className = 'hv-cd-row hv-cd-row--shipping';
      shipping.innerHTML = '<span class="hv-cd-label">Shipping</span><strong class="hv-cd-value hv-cd-value--free">FREE</strong>';
      totals.insertAdjacentElement('beforebegin', shipping);
    }
    /* The native Shopify subtotal changes on cart section re-render; do not replace its value. */
    var nativeRow = totals.querySelector('.cart-drawer__totals__row');
    var nativeSubtotal = nativeRow ? nativeRow.textContent.trim() : totals.textContent.trim();
    if (footer !== lastFooter || nativeSubtotal !== lastNativeSubtotal) {
      lastFooter = footer;
      lastNativeSubtotal = nativeSubtotal;
      fetchActualDiscount(footer);
    }
  }

  function setup() {
    var drawer = document.querySelector('cart-drawer') || document.getElementById('CartDrawer');
    if (!drawer) return;
    if (!observed.has(drawer)) {
      new MutationObserver(enhance).observe(drawer, { childList: true, subtree: true });
      observed.add(drawer);
    }
    enhance();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', setup, { once: true });
  else setup();
  document.addEventListener('shopify:section:load', setup);
})();

/* Homvista pet-focused refinement. Visual-only: native radio, cart form, prices, checkout and cart events stay intact. */
(function () {
  'use strict';
  var heart = '<svg class="hv-cd-heart" viewBox="0 0 24 24" fill="currentColor" stroke="none" aria-hidden="true" focusable="false"><path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78L12 21.23l8.84-8.84a5.5 5.5 0 0 0 0-7.78Z"/></svg>';
  var returnIcon = '<svg class="hv-cd-return-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false"><path d="M3 11a9 9 0 1 1 3 7"/><path d="M3 4v7h7"/></svg>';
  var announced = false;
  var redesignedDrawers = new WeakSet();

  function improveAnnouncement() {
    document.querySelectorAll('.hv-announce__desktop .hv-announce__item:last-child, .hv-announce__mobile .hv-announce__slide:last-child').forEach(function (item) {
      if (item.dataset.hvPetMessage === 'true') return;
      var label = item.querySelector('span');
      if (!label || label.textContent.trim().toLowerCase() !== 'secure checkout') return;
      label.textContent = 'For the pets who make every day better';
      var icon = item.querySelector('svg');
      if (icon) {
        icon.setAttribute('viewBox', '0 0 24 24');
        icon.setAttribute('fill', 'currentColor');
        icon.setAttribute('stroke', 'none');
        icon.setAttribute('aria-hidden', 'true');
        icon.classList.add('hv-announce__heart');
        icon.innerHTML = '<path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78L12 21.23l8.84-8.84a5.5 5.5 0 0 0 0-7.78Z"/>';
      }
      item.dataset.hvPetMessage = 'true';
    });
  }

  function improveVariants() {
    document.querySelectorAll('main#MainContent variant-selects .product-form__input--pills').forEach(function (group) {
      var radios = Array.from(group.querySelectorAll(':scope > input[type="radio"]'));
      /* Two-column option cards only when every value is compact; long kits stay full-width. */
      var compact = radios.length > 1 && radios.length <= 8 && radios.every(function (radio) { return radio.value.trim().length <= 17; });
      group.classList.toggle('hv-pills--compact', compact);
    });
  }

  function improveCart() {
    var drawer = document.querySelector('cart-drawer');
    if (!drawer) return;
    var hasItems = !drawer.classList.contains('is-empty') && !!drawer.querySelector('.cart-drawer-item');
    var body = drawer.querySelector('.cart-drawer__body');
    if (body && hasItems && !body.querySelector('.hv-cd-pet-banner')) {
      var banner = document.createElement('div');
      banner.className = 'hv-cd-pet-banner';
      banner.innerHTML = heart + '<span>Something special for your pet is in your cart.</span>';
      body.insertBefore(banner, body.firstChild);
    }
    if (body && !hasItems) {
      var old = body.querySelector('.hv-cd-pet-banner');
      if (old) old.remove();
    }
    var checkout = drawer.querySelector('#CartDrawer-Checkout');
    if (checkout && !drawer.querySelector('.hv-cd-returns-note')) {
      var returns = document.createElement('p');
      returns.className = 'hv-cd-returns-note';
      returns.innerHTML = returnIcon + '<span>30-Day Returns · <a href="/policies/refund-policy" style="color:#078C7B;text-decoration:underline;text-underline-offset:2px">View Return Policy</a></span>';
      checkout.insertAdjacentElement('afterend', returns);
    }
  }

  function initialize() {
    improveAnnouncement();
    improveVariants();
    var drawer = document.querySelector('cart-drawer');
    if (!drawer) return;
    if (!redesignedDrawers.has(drawer)) {
      new MutationObserver(improveCart).observe(drawer, { childList: true, subtree: true });
      redesignedDrawers.add(drawer);
    }
    improveCart();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialize, { once: true });
  else initialize();
  document.addEventListener('shopify:section:load', initialize);
})();

/* Homvista product-status refinement only. Leave Shopify forms, prices and cart logic intact. */
(function () {
  'use strict';
  var truck = '<svg class="hv-buy-status__truck" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false"><path d="M3 6h11v11H3zM14 10h4l3 4v3h-7"/><circle cx="7.5" cy="18" r="1.7"/><circle cx="17.5" cy="18" r="1.7"/></svg>';
  var styleText = 'main#MainContent .hv-buy-status{display:grid!important;grid-template-columns:max-content minmax(0,1fr)!important;align-items:center!important;justify-items:stretch!important;gap:6px!important;margin:3px 0 6px!important;padding:0!important;width:100%!important}' +
    'main#MainContent .hv-buy-status__stock,main#MainContent .hv-buy-status__shipping{display:flex!important;align-items:center!important;gap:5px!important;min-width:0!important;padding:0!important;margin:0!important}' +
    'main#MainContent .hv-buy-status__shipping{justify-content:flex-end!important;text-align:right!important}' +
    'main#MainContent .hv-buy-status__copy{display:block!important;min-width:0!important;line-height:1.2!important}' +
    'main#MainContent .hv-buy-status__title{font-size:clamp(10px,2.8vw,12px)!important;line-height:1.2!important;letter-spacing:0!important;font-weight:600!important}' +
    'main#MainContent .hv-buy-status__sub,main#MainContent .hv-buy-status__flag{display:none!important}' +
    'main#MainContent .hv-buy-status__dot{flex:0 0 7px!important;width:7px!important;height:7px!important;margin:0!important}' +
    'main#MainContent .hv-buy-status__truck{display:block;flex:0 0 14px;width:14px;height:14px;color:#078C7B}' +
    '@media(max-width:359px){main#MainContent .hv-buy-status{gap:3px!important}main#MainContent .hv-buy-status__stock,main#MainContent .hv-buy-status__shipping{gap:3px!important}main#MainContent .hv-buy-status__title{font-size:9px!important}main#MainContent .hv-buy-status__truck{width:12px;height:12px;flex-basis:12px}}';

  function selectedVariant(picker, variants, root) {
    if (!picker || !variants || !variants.length) return null;
    var groups = Array.from(picker.querySelectorAll('.product-form__input'));
    var values = groups.map(function (group) {
      var radio = group.querySelector('input[type="radio"]:checked');
      var select = group.querySelector('select');
      return radio ? radio.value : select ? select.value : null;
    });
    if (values.length && values.every(function (v) { return v !== null && v !== ''; })) {
      var match = variants.find(function (variant) {
        return values.every(function (value, index) { return variant['option' + (index + 1)] === value; });
      });
      return match || { available: false };
    }
    var idField = root.querySelector('form[action*="/cart/add"] input[name="id"]');
    var id = idField && idField.value;
    if (!id) id = new URLSearchParams(window.location.search).get('variant');
    return variants.find(function (variant) { return String(variant.id) === String(id); }) || variants[0];
  }

  function enhanceStatus() {
    var root = document.querySelector('main#MainContent');
    var status = root && root.querySelector('.hv-buy-status');
    if (!status) return;
    var shipping = status.querySelector('.hv-buy-status__shipping');
    if (shipping) {
      var flag = shipping.querySelector('.hv-buy-status__flag');
      if (flag) flag.remove();
      if (!shipping.querySelector('.hv-buy-status__truck')) shipping.insertAdjacentHTML('afterbegin', truck);
      var shippingTitle = shipping.querySelector('.hv-buy-status__title');
      if (shippingTitle && shippingTitle.dataset.hvFormatted !== 'true') {
        shippingTitle.innerHTML = '<span class="hv-buy-status__main-label">Free shipping</span><span class="hv-buy-status__region">Contiguous U.S.</span>';
        shippingTitle.dataset.hvFormatted = 'true';
        shipping.setAttribute('aria-label', 'Free shipping within the contiguous United States');
      }
    }
    status.querySelectorAll('.hv-buy-status__sub').forEach(function (sub) { sub.remove(); });
    var picker = root.querySelector('variant-selects');
    var variantJSON = picker && picker.querySelector('script[type="application/json"]');
    if (!variantJSON) return;
    var variants;
    try { variants = JSON.parse(variantJSON.textContent); } catch (error) { return; }
    var variant = selectedVariant(picker, variants, root);
    if (!variant) return;
    var stock = status.querySelector('.hv-buy-status__stock');
    if (!stock) return;
    var title = stock.querySelector('.hv-buy-status__title');
    var dot = stock.querySelector('.hv-buy-status__dot');
    var low = variant.available && variant.inventory_management === 'shopify' && variant.inventory_policy !== 'continue' && Number(variant.inventory_quantity) > 0 && Number(variant.inventory_quantity) <= 5;
    var message = !variant.available ? 'Currently unavailable' : low ? 'Only ' + Number(variant.inventory_quantity) + ' left' : 'Available to order';
    if (title && title.textContent !== message) title.textContent = message;
    if (dot) {
      dot.classList.toggle('hv-buy-status__dot--out', !variant.available);
      dot.classList.toggle('hv-buy-status__dot--low', !!low);
    }
  }

  var watched = new WeakSet();
  function initializeStatus() {
    var main = document.querySelector('main#MainContent');
    if (!main) return;
    if (!document.getElementById('hv-status-compact-style')) {
      var style = document.createElement('style');
      style.id = 'hv-status-compact-style';
      style.textContent = styleText;
      document.head.appendChild(style);
    }
    if (!watched.has(main)) {
      new MutationObserver(enhanceStatus).observe(main, { childList: true, subtree: true });
      watched.add(main);
    }
    enhanceStatus();
  }
  document.addEventListener('change', function (event) {
    if (event.target.closest('main#MainContent variant-selects')) {
      enhanceStatus();
      setTimeout(enhanceStatus, 75);
      setTimeout(enhanceStatus, 250);
    }
  });
  document.addEventListener('variant:change', enhanceStatus);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initializeStatus, { once: true });
  else initializeStatus();
  document.addEventListener('shopify:section:load', initializeStatus);
})();

/* Use the same Lucide v0.468.0 provider as the Homvista homepage for these requested UI icons. */
(function () {
  'use strict';
  var loading = false;
  var pending = false;
  var styles = [
    'html body main#MainContent .hv-buy-status{display:grid!important;grid-template-columns:minmax(0,1fr) minmax(0,1fr)!important;align-items:center!important;gap:9px!important;margin:5px 0 8px!important;padding:0!important}',
    'html body main#MainContent .hv-buy-status__stock,html body main#MainContent .hv-buy-status__shipping{display:flex!important;align-items:center!important;min-width:0!important;gap:7px!important}',
    'html body main#MainContent .hv-buy-status__stock{justify-content:flex-start!important}',
    'html body main#MainContent .hv-buy-status__shipping{justify-content:flex-end!important;text-align:right!important}',
    'html body main#MainContent .hv-buy-status__title{font-size:15px!important;line-height:1.2!important;font-weight:600!important;letter-spacing:0!important}',
    'html body main#MainContent .hv-buy-status__dot{height:9px!important;width:9px!important;flex:0 0 9px!important}',
    'html body main#MainContent .hv-buy-status__truck{height:20px!important;width:20px!important;flex:0 0 20px!important;stroke-width:1.8!important;fill:none!important}',
    'html body main#MainContent .hv-buy-status__copy{min-width:0!important}',
    'html body main#MainContent .hv-buy-status__region{display:inline!important;font-size:inherit!important;font-weight:inherit!important;white-space:nowrap!important}',
    'html body main#MainContent .hv-buy-status__main-label::after{content:" · "}',
    '@media(max-width:749px){html body main#MainContent .hv-buy-status__region{display:block!important;font-size:12px!important;line-height:1.2!important;font-weight:500!important;opacity:.85}html body main#MainContent .hv-buy-status__main-label::after{content:none}html body main#MainContent .hv-buy-status__shipping{max-width:50%!important}html body main#MainContent .hv-buy-status__main-label{white-space:nowrap!important}}',
    '@media(max-width:359px){html body main#MainContent .hv-buy-status__title{font-size:14px!important}html body main#MainContent .hv-buy-status__truck{height:20px!important;width:20px!important;flex:0 0 20px!important}}',
    'html body cart-drawer .hv-cd-heart,html body .hv-announce .hv-announce__heart{fill:currentColor!important;stroke:none!important}',
    'html body cart-drawer .hv-cd-return-icon,html body cart-drawer .hv-cd-lock,html body cart-drawer .hv-cd-truck,html body .hv-announce .hv-announce__icon:not(.hv-announce__heart){fill:none!important;stroke:currentColor!important;stroke-width:1.8!important}',
    'html body cart-drawer .hv-cd-return-icon{width:18px!important;height:18px!important;flex:0 0 18px!important}',
    'html body cart-drawer .hv-cd-lock{width:19px!important;height:19px!important;flex:0 0 19px!important}',
    'html body cart-drawer .hv-cd-truck{width:20px!important;height:20px!important;flex:0 0 20px!important}',
    'html body cart-drawer .hv-cd-heart{width:18px!important;height:18px!important;flex:0 0 18px!important}',
    'html body .hv-announce .hv-announce__icon{width:16px!important;height:16px!important;flex:0 0 16px!important}',
    'html body main#MainContent .hv-product-secure-lucide{width:18px!important;height:18px!important;stroke-width:1.8!important;fill:none!important;vertical-align:middle!important}'
  ].join('');

  function addStyle() {
    if (document.getElementById('hv-lucide-consistency-style')) return;
    var style = document.createElement('style');
    style.id = 'hv-lucide-consistency-style';
    style.textContent = styles;
    document.head.appendChild(style);
  }

  function queueIcon(node, name, filled, className) {
    if (!node || node.classList.contains('hv-lucide-managed')) return false;
    var placeholder = document.createElement('i');
    placeholder.setAttribute('data-lucide', name);
    placeholder.setAttribute('aria-hidden', 'true');
    placeholder.className = (className || (node.className && (node.className.baseVal || node.className)) || '') + ' hv-lucide-managed' + (filled ? ' hv-lucide-filled' : '');
    if (filled) placeholder.style.fill = 'currentColor';
    node.replaceWith(placeholder);
    return true;
  }

  function replaceIcons() {
    if (!window.lucide || !window.lucide.createIcons) return;
    var changed = false;
    var mappings = [
      ['main#MainContent .hv-buy-status__truck', 'truck', false],
      ['cart-drawer .hv-cd-heart', 'heart', true],
      ['cart-drawer .hv-cd-return-icon', 'rotate-ccw', false],
      ['cart-drawer .hv-cd-lock', 'lock-keyhole', false],
      ['cart-drawer .hv-cd-truck', 'truck', false]
    ];
    mappings.forEach(function (mapping) {
      document.querySelectorAll(mapping[0]).forEach(function (node) {
        if (queueIcon(node, mapping[1], mapping[2])) changed = true;
      });
    });
    document.querySelectorAll('.hv-announce .hv-announce__item, .hv-announce .hv-announce__slide').forEach(function (item) {
      var icon = item.querySelector('.hv-announce__icon');
      if (!icon) return;
      var isHeart = item.dataset.hvPetMessage === 'true' || icon.classList.contains('hv-announce__heart');
      var position = Array.prototype.indexOf.call(item.parentElement.children, item);
      var name = isHeart ? 'heart' : position === 0 ? 'truck' : position === 1 ? 'rotate-ccw' : 'shield-check';
      if (queueIcon(icon, name, isHeart)) changed = true;
    });
    document.querySelectorAll('main#MainContent img[src*="iconify.design/tabler/lock"]').forEach(function (node) {
      if (queueIcon(node, 'lock-keyhole', false, 'hv-product-secure-lucide')) changed = true;
    });
    if (changed) window.lucide.createIcons({ attrs: { 'stroke-width': 1.8 } });
  }

  function schedule() {
    if (pending) return;
    pending = true;
    requestAnimationFrame(function () { pending = false; replaceIcons(); });
  }

  function initialize() {
    addStyle();
    if (window.lucide && window.lucide.createIcons) {
      schedule();
    } else if (!loading) {
      loading = true;
      var script = document.createElement('script');
      script.src = 'https://unpkg.com/lucide@0.468.0/dist/umd/lucide.js';
      script.async = true;
      script.setAttribute('data-hv-lucide-core', 'true');
      script.onload = schedule;
      script.onerror = function () { loading = false; /* Keep existing SVG icons as fallback. */ };
      document.head.appendChild(script);
    }
    if (!document.body.dataset.hvLucideObserved) {
      document.body.dataset.hvLucideObserved = 'true';
      new MutationObserver(schedule).observe(document.body, { childList: true, subtree: true });
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialize, { once: true });
  else initialize();
  document.addEventListener('shopify:section:load', initialize);
})();
